import { Auth } from 'aws-amplify';
import { StateCreator } from 'zustand';

import { AuthUser } from '../typings';

type AuthStore = {
  isAuthenticated: boolean;
  user: AuthUser | null;
  setIsAuthenticated: (user?: boolean) => void;
  init: () => Promise<void>;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
};

export const createAuthState: StateCreator<AuthStore> = (set) => ({
  isAuthenticated: false,
  user: null,
  setIsAuthenticated: (isAuthenticated) => {
    set({
      isAuthenticated,
    });
  },
  init: async () => {
    try {
      const user = await Auth.currentUserInfo();

      set({ isAuthenticated: !!user, user });
    } catch (error) {
      console.log('auth init error:', error);
    }
  },
  login: async (username, password) => {
    await Auth.signIn({ username, password });
    const user = await Auth.currentUserInfo();

    set({ isAuthenticated: true, user });
  },
  logout: async () => {
    try {
      await Auth.signOut();
      set({ isAuthenticated: false, user: null });
    } catch (error) {
      console.log('logout error:', error);
    }
  },
});
